import Marionette from "backbone.marionette";
import $ from "jquery";
import _template from "lodash/template";

import { MISMATCH_TYPE } from "lib/constants";
import model from "../../models/positions";
import component from "../../components";

import MismatchReviewContainer from "./app-mismatch-review";

const ReviewContainer = Marionette.View.extend({
    data: {},
    getTemplate() {
        return _template('<div id="main"></div>');
    },
    initialize(opts) {
        this.data = opts.data;

        const positions = new model.Positions(this.data);
        this.mismatchPositions = new model.Positions(
            positions.filter((pos) => pos.hasSoftMismatch()),
        );
    },
    regions: {
        main: {
            selector: "#main",
        },
    },
    showSummary({ positions, questions = [], answerCount = 0, inviteCount = 0 }) {
        window.wsjs.candidate.init("APPLICATION_SUMMARY", {
            el: this.getRegion("main").el,
            state: {
                autoApplyEnabled: this.options.user.get("auto_apply_enabled"),
            },
            props: {
                activePIDs: window.activePids,
                answerCount,
                inviteCount,
                positions,
                questions,
                jobAlertsEnabled: this.options.user.get("sms_job_alerts_enabled"),
                phone: this.options.user.get("phone"),
            },
        });
    },
    showLoading({ softData = {}, positionSkip = [] } = {}) {
        if (window.sending) {
            return;
        }
        window.sending = true;

        const loading = new component.LoadingComponent({
            title: "Applying",
            subtitle: "Checking requirements...",
        });
        this.showChildView("main", loading);

        const self = this;
        const data = window.applicationData;

        const mismatchAck = {};

        const mismatchTypes = [
            MISMATCH_TYPE.AVAILABILITY,
            MISMATCH_TYPE.COMMUTE,
            MISMATCH_TYPE.LOCATION,
        ];
        mismatchTypes.forEach((mismatchType) => {
            const mismatchData = softData[mismatchType];
            if (mismatchData) {
                mismatchData.ack.forEach((a) => {
                    if (!mismatchAck[a]) {
                        mismatchAck[a] = [];
                    }
                    mismatchAck[a].push(mismatchType);
                });
            }
        });

        // remove acks where they passed on one of the soft fail mismatch
        positionSkip.forEach((p) => {
            delete mismatchAck[p];
        });

        data.mismatch_ack = mismatchAck;
        data.complete = 1;

        $.ajax({
            type: "POST",
            url: window.location.pathname,
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
        })
            .done((response) => {
                setTimeout(() => {
                    self.showSummary(response);
                }, 2800);
            })
            .fail(() => {
                setTimeout(() => {
                    /* eslint-disable no-alert */
                    window.alert(
                        "The application could not be submitted. Please check " +
                            "your internet connection and try again.",
                    );
                    /* eslint-enable no-alert */
                }, 150);
            })
            .always(() => {
                window.sending = false;
            });
    },
    onRender() {
        if (this.mismatchPositions.length === 0) {
            this.showLoading();
            return;
        }

        const $mismatchReview = $('<div id="soft-container"><div id="soft-review"></div></div>');
        this.$el.append($mismatchReview);

        const mismatchView = new MismatchReviewContainer({
            el: $mismatchReview,
            data: this.data,
            user: this.options.user,
            positions: this.mismatchPositions,
        });

        this.listenTo(mismatchView, "finish", (data) => {
            $mismatchReview.remove();
            this.showLoading(data);
        });
    },
});

export default ReviewContainer;
